import { type UserReference, type ErrorResult } from '@databases/types/confluence';
import { getBulkUserByIds } from '@databases/utils/confluence/user';

import { DataLoaderService } from './base/data-loader-service';

export class UserDataLoader extends DataLoaderService<string, UserReference> {
  protected batchLoad(accountIds: string[]): Promise<(UserReference | ErrorResult)[]> {
    return Promise.all(
      Array.from(accountIds).map(async (accountId) => {
        const knownUsers = await getBulkUserByIds([accountId]);
        for await (const knownUser of knownUsers) {
          if (knownUser.accountId) {
            return {
              accountId: knownUser.accountId,
              displayName: knownUser.displayName
            };
          }
        }
        return { message: `User not found: ${accountId}`, status: 404 };
      })
    );
  }
}
